/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ConstructionDayReport } from '../../models/construction-day-report';
import { ReportCreationResult } from '../../models/report-creation-result';

export interface ApiV0ConstructiondayreportCreateReportPost$Json$Params {
      body?: ConstructionDayReport
}

export function apiV0ConstructiondayreportCreateReportPost$Json(http: HttpClient, rootUrl: string, params?: ApiV0ConstructiondayreportCreateReportPost$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<ReportCreationResult>> {
  const rb = new RequestBuilder(rootUrl, apiV0ConstructiondayreportCreateReportPost$Json.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ReportCreationResult>;
    })
  );
}

apiV0ConstructiondayreportCreateReportPost$Json.PATH = '/api/v0/constructiondayreport/createReport';
